
export default {
  layout: 'technos',
}
